import type { FC } from "react"

import { useWarehouseShelvingFilter } from "../hooks/useWarehouseShelvingFilter"

import { WarehouseShelvingFilter } from "./WarehouseShelvingFilter"

import { SearchFilterDrawer } from "@/components/common/SearchFilterDrawer/SearchFilterDrawer"

interface SearchFilterProps {
  showFilter: boolean
  toggleFilter: () => void
}

export const WarehouseShelvingFilterDrawer: FC<SearchFilterProps> = ({ showFilter, toggleFilter }) => {
  const {
    formMethods,
    utils: { clearFilterAll, changeFilter, enableFilterIfChecked },
    isFilterEmpty,
    clearBinStatus,
    changeBinStatus,
  } = useWarehouseShelvingFilter()

  return (
    <SearchFilterDrawer
      toggleDrawer={toggleFilter}
      open={showFilter}
      clear={clearFilterAll}
      isClearButtonEnabled={!isFilterEmpty()}
      testId='warehouse-shelving-filter-drawer'
    >
      <WarehouseShelvingFilter
        changeFilter={changeFilter}
        formMethods={formMethods}
        clearBinStatus={clearBinStatus}
        enableFilterIfChecked={enableFilterIfChecked}
        changeBinStatus={changeBinStatus}
      />
    </SearchFilterDrawer>
  )
}
